<template>
    <BasePanel
        headline='lang_PUBLISHING_CAPTION_WORKS'
        :alvqa="alvqa"
    >
        <template v-slot:panelContent>
            <v-data-table         
                :headers="headers"
                hide-default-footer
                :items="listItems"
                item-key="index"
                :header-props="{ sortIcon: '' }"
                :items-per-page="itemsPerPage"
                class="noMinWidth"
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                id="worksList"
            >
            <!-- Headers -->
                <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                    <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                </template>

            <!-- Items -->
                <!-- TITLE -->
                <template v-slot:[`item.title`]="{ item }">
                    <BaseTooltip>
                        <template v-slot:content>
                            <div 
                                class='no_ellipsis'
                                :alvqa="alvqa + '-works-' + item.id + '-text-title'"
                            >{{ item.title }}</div>
                        </template>
                        <template v-slot:text>{{ item.title }}</template>
                    </BaseTooltip>
                </template>
                <!-- COMPOSERS -->
                <template v-slot:[`item.composers`]="{ item }">
                    <BaseTooltip>
                        <template v-slot:content>
                            <div 
                                class="ellipsis"
                                :alvqa="alvqa + '-works-' + item.id + '-text-composers'"
                            >{{ item.composers.join(" / ") }}</div>
                        </template>
                        <template v-slot:text>{{ item.composers.join(" / ") }}</template>
                    </BaseTooltip>
                </template>
                <!-- PUBLISHERS -->
                <template v-slot:[`item.publishers`]="{ item }">
                    <BaseTooltip>
                        <template v-slot:content>
                            <div 
                                class="ellipsis"
                                :alvqa="alvqa + '-works-' + item.id + '-text-publishers'"
                            >{{ item.publishers.join(" / ") }}</div>
                        </template>
                        <template v-slot:text>{{ item.publishers.join(" / ") }}</template>
                    </BaseTooltip>
                </template>
                <!-- WORK ID -->
                <template v-slot:[`item.gemaNumber`]="{ item }">
                    <div :alvqa="alvqa + '-works-' + item.id + '-text-work-id'">
                        {{ item.gemaNumber }}
                    </div>
                </template>
                <!-- DURATION Film/TV -->
                <template v-slot:[`item.workSheetSeconds`]="{ item }">
                    <div :alvqa="alvqa + '-works-' + item.id + '-text-work-sheet-seconds'">
                        {{ item.workSheetSeconds !== null ? $alvPlugin.transformSecondsToDuration(item.workSheetSeconds) + ' (' + (item.workSheetSeconds) + ')' : '' }}
                    </div>
                </template>
                <!-- DURATION Setlist -->
                <template v-slot:[`item.workSetlistSeconds`]="{ item }">
                    <div :alvqa="alvqa + '-works-' + item.id + '-text-work-setlist-seconds'">
                        {{ item.workSetlistSeconds !== null ? $alvPlugin.transformSecondsToDuration(item.workSetlistSeconds) + ' (' + (item.workSetlistSeconds) + ')' : '' }}
                    </div>
                </template>
                <!-- AV TYPE -->
                <template v-slot:[`item.workAvType`]="{ item }">
                    <div class="ellipsis">
                        <BaseTooltip 
                            :simpleText="$t(getWorkAvType(item.workAvType))"
                            :alvqa="alvqa +'-list-row-' + item.alvId + '-text-work-av-type'"
                        />
                    </div>
                </template>
                <!-- SETLIST TYPE -->
                <template v-slot:[`item.workSetlistType`]="{ item }">
                    <div :alvqa="alvqa +'-list-row-' + item.alvId + '-text-work-setlist-type'">

                        {{ getSetlistType(item.workSetlistType) }}
                    </div>
                </template>
                <!-- CHARACTERISTIC -->
                <template v-slot:[`item.workCharacteristicType`]="{ item }">
                    <div class="ellipsis">
                        <BaseTooltip 
                            :simpleText="$t(getWorkCharacteristicType(item.workCharacteristicType))"
                            :alvqa="alvqa +'-list-row-' + item.alvId + '-text-work-characteristic'"
                        />
                    </div>
                </template>
                <!-- BIG RIGHT -->
                <template v-slot:[`item.bigRight`]="{ item }">
                    <div class="ellipsis">
                        <BaseTooltip 
                            :simpleText="$t(getBigRight(item.bigRight))"
                            :alvqa="alvqa +'-list-row-' + item.alvId + '-text-big-right'"
                        />
                    </div>
                </template>
                <!-- STATUS -->
                <template v-slot:[`item.status`]="{ item }">
                    <div :alvqa="alvqa + '-works-' + item.id + '-text-status'">
                    {{ $t(getStatus(item.status)) }}
                    </div>
                </template>
            </v-data-table>
            <!-- PAGINATION component -->
            <v-pagination   
                v-if="pages() > 1"
                total-visible="10" 
                v-model="currentPage" 
                :length="pages()"
                color="pagination"
                @input="nextPage()"
            ></v-pagination>
        </template>
    </BasePanel>
</template>

<script>
    import 
    {   
        DropdownPublishingWorksStatus,
        DropdownPublishingSheetsWorkAvType,
        DropdownPublishingSheetsWorkCharacteristicType,
        DropdownPublishingSheetsWorkSetlistType, 
        DropdownGenericYesNo,
    } 
from '@/assets/dropdowns/alvDropdowns.js'

import BasePanel from '@/components/_base/BasePanel'
import BaseTooltip from '@/components/_base/BaseTooltip'

export default {
    name: "WorksReadonlyPanel",
    components: {
        BasePanel,
        BaseTooltip
    },
    props: {
        sheetAlvId: {
            type: String
        }
    },
    data() {
        return {
            alvqa: 'publishing-sheets-list-row-' + this.sheetAlvId + '-read-only-panel-works',
            currentPage: 1
        }
    },
    computed: {
        item() {
            let item = this.$store.getters.getExpandedSheets.find(element => {
                return element.alvId === this.sheetAlvId
            })          
            return item
        },

        listItems(){
            let items = this.item.works
            let startIndex = (this.currentPage - 1) * this.itemsPerPage
            let endIndex = startIndex + this.itemsPerPage
            if( items.length < this.itemsPerPage) { return items }
            return items.slice(startIndex, endIndex)
        }, 

        headers() {
            return [
                {
                    text: this.$t('lang_PUBLISHING_SHEETS_CAPTION_WORK_TITLE'), 
                    value: 'title', 
                    align: 'left', 
                    sortable: false,
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + '-works-header-title'
                },
                {
                    text: this.$t('lang_PUBLISHING_CAPTION_COMPOSERS'), 
                    value: 'composers', 
                    align: 'left', 
                    sortable: false, 
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + '-works-header-composers'
                }, 
                {
                    text: this.$t('lang_PUBLISHING_CAPTION_PUBLISHERS'), 
                    value: 'publishers', 
                    align: 'left', 
                    sortable: false,
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + '-works-header-publishers'
                },
                {
                    text: this.$t('lang_PUBLISHING_WORKS_CAPTION_WORK_ID'), 
                    value: 'gemaNumber', 
                    align: 'left', 
                    sortable: false, 
                    width: "140px",
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + '-works-header-work-id'
                },
                {
                    text: this.$t('lang_PUBLISHING_SHEETS_CAPTION_SECONDS'), 
                    value: this.sheetType === 'film/tv' ? 'workSheetSeconds' : 'workSetlistSeconds',
                    align: 'left', 
                    sortable: false,
                    width: "120px",
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + '-works-header-duration'
                }, 
                {
                    text: this.$t("lang_PUBLISHING_SHEETS_CAPTION_TYPE"), 
                    value: this.sheetType === 'film/tv' ? 'workAvType' : 'workSetlistType', 
                    align: 'left', 
                    sortable: false, 
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + "-works-header-work-av-type"
                }, 
                {
                    text: this.$t(this.sheetType === 'film/tv' ? "lang_PUBLISHING_SHEETS_CAPTION_CHARACTERISTIC" : "lang_GENERAL_CAPTION_TYPE_OF_RIGHTS_BIG_RIGHT"),
                    value: this.sheetType === 'film/tv' ? 'workCharacteristicType' : 'bigRight', 
                    align: 'left', 
                    sortable: false, 
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + "-works-header-work-characteristic"
                }, 
                {
                    text: this.$t('lang_PUBLISHING_WORKS_CAPTION_STATUS'), 
                    value: 'status', 
                    align: 'left', 
                    sortable: false, 
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + '-works-header-status'
                }
            ]
        },
        itemsPerPage() { return this.$store.getters.getItemsPerPage },
        sheetType() { return this.$store.getters.getSheetDetailsType },
    },
    methods: {
        getWorkAvType(typeValue) {
                let match = DropdownPublishingSheetsWorkAvType.find(type => {
                    return type.value === typeValue
                })

                if(match !== undefined) {
                    return match.text
                }
        },
        getSetlistType(typeValue) {
            let match = DropdownPublishingSheetsWorkSetlistType.find(type => {
                return type.value === typeValue
            })
            if(match !== undefined) return match.text
        },
        getWorkCharacteristicType(typeValue) {
            let match = DropdownPublishingSheetsWorkCharacteristicType.find(type => {
                return type.value === typeValue
            })

            if(match !== undefined) return match.text
        },
        getStatus(dbValue) {
            return DropdownPublishingWorksStatus.find(status => {
                return status.value === dbValue
            }).text
        },
        getBigRight(bigRightValue) {
            if(bigRightValue !== null && bigRightValue !== undefined) {
                let match = DropdownGenericYesNo.find(element => {
                    return element.value === bigRightValue
                })
                return this.$t(match.text)
            } else {
                return null
            }
        },

        pages() {
            if (this.item.works.length < this.itemsPerPage) return 0 
            return Math.ceil(this.item.works.length / this.itemsPerPage)
        },

        nextPage(){
            setTimeout(() => {
                this.$vuetify.goTo('#worksList')
            }, 500);
        }
    }
}
</script>